import { render, staticRenderFns } from "./score_card.vue?vue&type=template&id=0fe7db5e&"
import script from "./score_card.vue?vue&type=script&lang=js&"
export * from "./score_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports